var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionShowOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm-2 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 4c8 0 12 8 12 8s-4 8-12 8-12-8-12-8 4-8 12-8Zm-9.679 8a16.261 16.261 0 0 1 2.093-2.586C6.196 7.632 8.718 6 12 6c3.283 0 5.804 1.632 7.586 3.414.95.95 1.651 1.908 2.093 2.586a16.262 16.262 0 0 1-2.093 2.586C17.804 16.368 15.283 18 12 18c-3.282 0-5.804-1.632-7.586-3.414A16.262 16.262 0 0 1 2.321 12Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionShowOutlined);
export default __webpack_public_path__ + "static/media/ic_action_show_outlined.30ef43ea768b88347509f14f82c8afd5.svg";
export { ForwardRef as ReactComponent };